
export const GET_SLIDER_REQUEST = 'GET_SLIDER_REQUEST';
export const GET_SLIDER_SUCCESS = 'GET_SLIDER_SUCCESS';
export const GET_SLIDER_FAIL = 'GET_SLIDER_FAIL';
